import Hidden, { HiddenProps } from '@material-ui/core/Hidden';
import React from 'react';

interface Props extends HiddenProps {
  children?: React.ReactNode;
}

const HiddenComponent = (props: Props) => {
  const { children } = props;

  return (
    <Hidden {...props}>
      {children}
    </Hidden>
  );
};

export default HiddenComponent;
